import { isBrowser } from '@scentregroup/shared/env'

export const scrollToTop = (): void => {
  isBrowser() && window.scrollTo(0, 0)
}
